export interface Notification {
  headline: string;
  subline?: string;
  type: NotificationType;
  origin?: string;
  closable?: boolean;
  key?: string;
}

export enum NotificationType {
  Success = 'SUCCESS',
  Error = 'ERROR'
}
